<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Créer une nouvelle FAQ</strong>
          </div>

            <b-form-group
              label="Question"
              label-for="question"
            >
            	<b-form-input id="question" type="text" :class="{hasError: errors.question !== ''}" v-model="question"></b-form-input>
              <span class="field-error">{{ errors.question }}</span>
            </b-form-group>

            <b-form-group>
                <editor :content.sync="contentForEditor" useCustomImageHandler @image-added="handleImageAdded" v-model="reponse"></editor>
                <span class="field-error">{{ errors.contentForEditor }}</span>
            </b-form-group>

            <b-form-group>
                <label for="type"><strong>Type</strong></label>
                <b-form-select id="type"
                    :plain="true"
                    :options="[
                        {text: 'Questions générales', value: 'QG'},
                        {text: 'Rente invalidité', value: 'INVAL'},
                        {text: 'Rente conjoint, éducation', value: 'COED'}
                    ]"
                    v-model="selectedType"
                />
            </b-form-group>

            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des FAQ
              </b-button>
              <b-button type="button" @click="add" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "@/utils/auth"
import Editor from '../../../../components/Editor.vue'

export default {
  components: {
    Editor
  },
  data() {
  	return {
      reponse: '',
      question: '',
      contentForEditor: '',
      selectedType: '',
      errors: {
        question: '',
        reponse: '',
        contentForEditor: ''
      },
      contentForEditor: ''
  	}
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        var formData = new FormData()
        formData.append('file', file)
        let self = this

        let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        }
        this.$axios.post('/espaceBeneficiaire/adminfaq/upload', formData, config).then((response) => {
            let url = response.data.url
            Editor.insertEmbed(cursorLocation, 'image', url)
            resetUploader();
        }).catch(function () {
            self.$store.commit('IS_LOADING', false)
            self.$swal( {
                position: 'top',
                type: 'error',
                title: 'Attention',
                text: 'Un problème est survenu pendant le chargement de l\'image',
                showConfirmButton: false,
                timer: 0
            })
        })
    },
    add() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        let id = this.$route.params.id;
        let dataPost = {};
        dataPost.question = this.question;
        dataPost.reponse = this.contentForEditor;
        dataPost.type = this.selectedType;

        this.$axios
          .post("/espaceBeneficiaire/adminfaq", dataPost)
          .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Création avec succès', text:'La nouvelle FAQ a bien été créée',showConfirmButton: false, timer: 5000})
              this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq' })
              this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',showConfirmButton: false, timer: 5000})
          });
      }
    },
    returnBack() {
      this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq' })
    },
    validateData () {
      this.clearErrors();
   
      let valid = true;

      if (this.question === "") {
        this.errors.question = "La question est obligatoire";
        valid= false;
      } 
    //   else if (this.question.length > 90) {
    //      valid = false
    //      this.errors.question  = 'Veuillez entrer une question moins longue'
    //   }

    //   if (this.reponse.trim() === '') {
    //      valid= false;
    //      this.errors.reponse = 'Veuillez entrer une réponse'
    //   } 
    //   else if (this.reponse.length > 90) {
    //      valid = false
    //      this.errors.reponse  = 'Veuillez entrer une reponse moins longue'
    //   }

      if (this.contentForEditor.trim() === '') {
         valid= false;
         this.errors.contentForEditor = 'Veuillez entrer une réponse'
      } 

      return valid;
    },
    clearErrors() {
      this.errors.question = "";
      this.errors.reponse = "";
      this.errors.contentForEditor = "";
    }
  }
};
</script>

<style>
</style>
